import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Upload } from "lucide-react";

export function StudentUploadButton() {
  const { user } = useAuth();
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState("");
  const [file, setFile] = useState(null);

  const mut = useMutation({
    mutationFn: async () => {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("label", label.trim() || file.name);
      return (await api.post(`/students/${user.student_id}/documents`, fd)).data;
    },
    onSuccess: () => {
      toast.success("Documento caricato. La segreteria è stata avvisata.");
      qc.invalidateQueries({ queryKey: ["portal-my-documents"] });
      setOpen(false); setLabel(""); setFile(null);
    },
    onError: (e) => toast.error(e?.response?.data?.detail || "Errore durante il caricamento"),
  });

  return (
    <>
      <Button size="sm" onClick={() => setOpen(true)} className="rounded-full bg-[#1C352D] hover:bg-[#264A3E]" data-testid="portal-doc-upload-btn">
        <Upload size={14} className="mr-1.5" /> Carica documento
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="portal-doc-upload-dialog">
          <DialogHeader><DialogTitle>Carica un documento</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome del documento</Label>
              <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Es. Certificato medico" className="mt-1.5" data-testid="portal-doc-label-input" />
            </div>
            <div>
              <Label>File (PDF o immagine, max 15 MB)</Label>
              <Input type="file" accept=".pdf,.png,.jpg,.jpeg,.webp" onChange={(e) => setFile(e.target.files?.[0] || null)} className="mt-1.5" data-testid="portal-doc-file-input" />
            </div>
            <div className="text-xs text-stone-500">Il file sarà visibile a te e alla segreteria. Per eliminarlo dovrai chiedere alla segreteria.</div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} data-testid="portal-doc-cancel-btn">Annulla</Button>
            <Button onClick={() => mut.mutate()} disabled={!file || mut.isPending} data-testid="portal-doc-submit-btn">
              {mut.isPending ? "Caricamento…" : "Carica"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
